import InterfaceRenderer__LinkInstructions from '@runtime/TypescriptMetadataRenderer/interface';
import DemoRenderer__LinkInstructions from '@runtime/DemoRenderer';
import Basic_1866643200, { _demoInfo as Basic_1866643200_demoInfo } from "../../../../../packages/console-sankey-chart/demo/Basic.tsx?loadDemo";
import MultiCol_1866643200, { _demoInfo as MultiCol_1866643200_demoInfo } from "../../../../../packages/console-sankey-chart/demo/MultiCol.tsx?loadDemo";
import LinkStyle_1866643200, { _demoInfo as LinkStyle_1866643200_demoInfo } from "../../../../../packages/console-sankey-chart/demo/LinkStyle.tsx?loadDemo";
import Vertical_1866643200, { _demoInfo as Vertical_1866643200_demoInfo } from "../../../../../packages/console-sankey-chart/demo/Vertical.tsx?loadDemo";
import NodeAlign_1866643200, { _demoInfo as NodeAlign_1866643200_demoInfo } from "../../../../../packages/console-sankey-chart/demo/NodeAlign.tsx?loadDemo";
import Topology_1866643200, { _demoInfo as Topology_1866643200_demoInfo } from "../../../../../packages/console-sankey-chart/demo/Topology.tsx?loadDemo";
import TopologyVertical_1866643200, { _demoInfo as TopologyVertical_1866643200_demoInfo } from "../../../../../packages/console-sankey-chart/demo/TopologyVertical.tsx?loadDemo";
import React from 'react';
export default {
  InterfaceRenderer__LinkInstructions,
  DemoRenderer__LinkInstructions,
  Basic_1866643200,
  Basic_1866643200_demoInfo,
  MultiCol_1866643200,
  MultiCol_1866643200_demoInfo,
  LinkStyle_1866643200,
  LinkStyle_1866643200_demoInfo,
  Vertical_1866643200,
  Vertical_1866643200_demoInfo,
  NodeAlign_1866643200,
  NodeAlign_1866643200_demoInfo,
  Topology_1866643200,
  Topology_1866643200_demoInfo,
  TopologyVertical_1866643200,
  TopologyVertical_1866643200_demoInfo,
  React
};